import { DashboardViewFragment } from 'generated/graphql';
import pathJoin from 'v2/core/utils/path';
import { getDashboardRoute } from './getDashboardRoute';

export const getDashboardLink = (
  dashboard: Pick<DashboardViewFragment, 'viewToken' | 'title'>,
  tenantSlug?: string,
): string => {
  return pathJoin(
    window.location.origin,
    tenantSlug ?? '',
    getDashboardRoute(dashboard),
  );
};
